import { Component, createRef } from "react";
import { connect } from "react-redux";
import {set_datapage} from '@ora/recursos/src/redux/actions/DataPageAction'
import { baseUrl, getValuesQueryArray, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import { Button, Card, Section } from 'react-bulma-components';
import $ from 'jquery'
import dt from 'datatables.net'
import Swal from "sweetalert2";
import qs from 'query-string'
import {PageLength} from "helpers/Datatables";


$.DataTable = dt

class Darwin extends Component {
    _isMounted = false;
    requestInit = null;
    refFilterRecursos = null
    state = {
        listRecursos: [],
        import_vars: [],
        search:{txt_recurso:"",sel_tipo: ""},
        total:0,
        isloadsearch: false

    }
    filter = {
        buscar: '',
        type: -1,
        dublin: -1
    }
    table = null
    datatable = null
    constructor (props) {
        super(props)
        
        // this.props.set_datapage('Importar otro')
        this.requestInit = axios.CancelToken.source()
        this.refFilterRecursos = createRef()
        this.props.set_datapage({
            titulo: 'Hologacion de Especimenes',
            subTitulo: '',
            isbackend:true,
            breadcrumb:[
                {name:"Intranet",url:"#"},
                {name:"Recoleccion",url:"#"},
                {name:"Hologacion de Especimenes",url:"#",active:true},
        ]});
    }
    componentDidMount () {
        if(!this._isMounted){
            this.initpage()
            this._isMounted = true;
        }
        
        var params=qs.parse(this.props.location.search)
        var search=this.state.search
        if((params["q1"])){
            search['txt_recurso']=params["q1"]
        }
        if((params["q2"])){
            search['sel_tipo']=params["q2"]
        }

        
    }

    initpage = () => {

        let filterResource = getValuesQueryArray(this.props.location, 'resource')
       
        axios.get(baseUrl('cites/homologar?tabla=darwin_core'), { cancelToken: this.requestInit.token }).then(res => {
            if (res.data.success) {
                this._isMounted && this.setState({
                    listRecursos: res.data.data.recursos.filter(item => {
                        return filterResource.length > 0 ? filterResource.includes(item.id) : true
                    }),
                    // import_vars: res.data.data.import_vars
                })
                if (filterResource.length > 0) {
                    this.refFilterRecursos.current.value = filterResource[0]
                    this.filter.recurso = filterResource[0]
                }
                if(this.state.search['sel_tipo']!="-1" && this.state.search['sel_tipo']!=""){
                    //this.onSeacrh();
                }
            }
        })        
    }
    initDatatable(){

        const OnCall = () => {

            this.setState({                   
                isloadsearch: true
            })
            
       }
       const OnFinish = () => {

        this.setState({                   
            isloadsearch: false
        })
        
    }

      
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns'<'column'l><'column'p>>",
            // dom: "<'b-table'<'table-wrapper'<'table-container't>><'top level'<'level-left'l><'level-right'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/homologar/datatabledarwin"),
              data: (d) => {
                d.filter = this.getFilter()
                return d
              },
              beforeSend: function () {
                OnCall(); // show wating animation
              },
              error: function (xhr, error, thrown) {
                OnFinish()
                //alert(xhr.status);
                //alert(thrown);
                Swal.fire({
                    title: thrown,
                    html: `
                     <p> Se encontró un error en el servidor, intente más tarde.</p>
                     <p>Mensaje: ${xhr.status} - ${error}</p>
                    `,
                    icon: 'error'
                }).then(sr => {
                    
                  })
                
              }
              
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            //   new Vue().$mount(r.querySelector(".cell-options"));
            },
            columns: [
              { data: "dar_int_id"},
              { data: "dar_txt_scientific_name" },
              { data: "dar_txt_cite_f" },
              { data: "pli_txt_cite_bf" },
              { data: "dar_txt_uicn" },
              { data: "pli_txt_uicn_b" },
              { data: "dar_bit_amazonian",render: (d, t, r)=>{
                if(d=="f"){
                    return "Si"
                }else{
                    return "No"
                }
                
                }},
              { data: "dar_txt_homologated" }
            ],
            drawCallback: (dcall) => {
                this.setState({                   
                    total:dcall._iRecordsDisplay,
                    isloadsearch: false
                })
                $('#tblDarwinHomologar_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblDarwinHomologar_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblDarwinHomologar_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblDarwinHomologar_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblDarwinHomologar_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblDarwinHomologar')
        
        this.datatable = this.table.DataTable(this.configDT)
        

    }
    COptionRecursos = () => {
        return this.state.listRecursos.map((item, index) => {
            var selected=false
            if(this.state.search['sel_tipo']==item.id){selected=true}
        return (<option key={index} value={item.id} selected={selected}>{item.name}</option>)
    })
    }
    getFilter(){
        return  {
            nombre: this.state.search['txt_recurso'],
            recurso: this.state.search['sel_tipo']           
            }
      
    }
    onSeacrh = () => {

        
        
        if (this.state.search.sel_tipo!="" && this.state.search.sel_tipo!="-1"){
            this.setState({  
                isloadsearch: true
            })
            var url=this.getParamsUrl("/recoleccion/homologacion/darwin?");  
            this.props.history.push(localUrl(url))   
            if(this.datatable){
                this.datatable.draw()
            }else{
                this.initDatatable()
            }
        }else{
            Swal.fire({
                title: 'Alerta',
                html: `
                   <p>Debe seleccionar un recurso.</p>
                `,
                icon: 'warring'
            }).then(sr => {
                
              })
        }

    }
    getParamsUrl(url){
        if(this.state.search['txt_recurso']!=""){
            url+="&q1="+this.state.search['txt_recurso']

        }
        if(this.state.search['sel_tipo']!=""){
            url+="&q2="+this.state.search['sel_tipo']

        }
        
        return url;

    }
    gestionarCambio = (event) => {
        var search=this.state.search
        if (event.target.type === "radio") {
            search[event.target.name]=event.target.value;
        } else {
            search[event.target.id]=event.target.value;
        }
        this.setState({          
            search:search
        })
      };
    requestHomologar = (value) => {
        this.setState({                   
            isloadsearch: true
        })
        axios.get(`${this.datatable.ajax.url()}?${$.param(this.datatable.ajax.params())}&homologar=${value}`).then(res => {
            if (res.data.success) {
                this.datatable.draw()
                this.setState({                   
                    isloadsearch: false
                })
                Swal.fire({
                    title: 'Homologación',
                    html: `
                        <h3>Resultados</h3>
                        <table class="table is-narrow" style="width: 100%">
                        
                        <tbody>
                          <tr>
                            <td class="has-text-left">Cites</td>
                            <td class="has-text-centered">${res.data.data.cites}</td>
                          </tr>
                          <tr>
                            <td class="has-text-left">IUCN</td>
                            <td class="has-text-centered">${res.data.data.iucn}</td>
                          </tr>
                          <tr>
                            <td class="has-text-left">Amazonica</td>
                            <td class="has-text-centered">${res.data.data.amazonica}</td>
                          </tr>
                        </tbody>
                      </table>
                    `,
                    icon: 'success'
                }).then(sr => {
                    
                  })
            }
        })
    }
    onClick_homologarCites = () => {
        this.requestHomologar('cites')
    }
    onClick_homologarIucn = () => {
        this.requestHomologar('uicn')
    }
    onClick_homologarAmazonica = () => {
        this.requestHomologar('amazonica')
    }
    onClick_homologarTodos = () => {
        this.requestHomologar('all')
    }
    OnClick_acciones = (evt) => {
        //   console.log(this.props)
          let {accion, id} = evt.currentTarget.dataset
          switch (accion) {
            case 'ver':
              this.props.history.push(localUrl('/config/exportaciones/' + id))
              break;
            case 'editar':
              this.props.history.push(localUrl('/config/exportaciones/' + id + '/edit'))
              break;
            case 'estado':
              axios.put(baseUrl('cites/exportaciones/' + id + '?m=estado')).then(res => {
                  if (res.data.success) {
                      this.datatable.draw(false)
                  }
                Swal.fire(
                    'Exportaciones',
                    res.data.message,
                    'success'
                  ).then(sr => {
                    
                  })
              })
              break;
            case 'eliminar':
              axios.delete(baseUrl('cites/exportaciones/' + id)).then(res => {
                  if (res.data.success) {
                      this.datatable.draw(false)
                  }
                Swal.fire(
                    'Exportaciones',
                    res.data.message,
                    'error'
                  ).then(sr => {
                    
                  })
              })
              break;
          
            default:
              break;
          }
        }
    render() {
        return (
            <section className="section is-main-section">
                <div className="card">
                    <header className="card-header">
                        <p className="card-header-title">
                            <span className="icon"><i className="mdi mdi-finance"></i></span>
                            Proceso de homologación de especies en la base de datos
                        </p>                       
                    </header>
                    <div className="card-content">
                        <p className="has-text-justified">
                            La homologación de especies registradas en la base de datos, consistes en actualizar o asignar los valores de los apéndices CITES o categorías de la UICN desde fuentes oficiales internacionales respectivamente CITES.ORG y IUCNREDLIST.ORG. 
                            <br/>
                            Primero seleccione el recurso sobre el cual se va a realizar la homologación, segundo visualice y compare los datos, finalmente seleccione el proceso de homologación a realizar CITES u IUCN. 
                        </p>
                        <hr/>
                        
                        
                <div className="field is-horizontal">
                    <div className="field-body">
                        <div className="column is-4">
                            <div className="field">
                                <div className="control has-icons-left has-icons-right">
                                    <input type="text"
                                        autoComplete="on" placeholder="Nombre" id="txt_recurso" name="txt_recurso" onChange={this.gestionarCambio} className="input form-control" value={this.state.search.txt_recurso} /><span className="icon is-left"><i
                                            className="fas fa-search"></i></span></div>
                              
                            </div>
                        </div>
                        <div className="column is-3">
                        <div className="field">
                            <div className="control">
                                <span className="select is-empty">
                                    <select ref={ this.refFilterRecursos }  id="sel_tipo" name="sel_tipo"  onChange={this.gestionarCambio}  required="required">
                                        <option  value="-1"> - Seleccione un Recurso -
                                        </option>
                                        {this.COptionRecursos()}
                                        
                                    </select></span></div>
                        </div>
                        </div>
                        {/* <div className="column is-3">
                        <div className="field">
                            <div className="control">
                                <span className="select is-empty">
                                    <select name="filterType" onChange={ this.onChange } required="required">
                                        <option  value="-1"> - Tipo -
                                        </option>
                                        {this.COptionDublin()}
                                        
                                    </select></span></div>
                        </div>
                        </div> */}
                        <div className="column">
                            <Button className={"is-success "+(this.state.isloadsearch?"is-loading":"")} onClick={this.onSeacrh}>Buscar</Button>
                        </div>
                       
                    </div>
                </div>
                <hr/>
                    <div className="columns">
                        <div className="column is-3">
                            <div className="buttons level-left">
                                {this.state.total!=0?this.state.total+" registros":""}
                            </div>
                            
                        </div>
                        <div className="column is-9">
                            {this.datatable?(
                            <div className="buttons level-right">

                                    <Button type="button" onClick={ this.onClick_homologarCites } className="is-info">Homologar Cites</Button>
                                    <Button type="button" onClick={ this.onClick_homologarIucn } className="is-info">Homologar IUCN</Button>
                                    <Button type="button" onClick={ this.onClick_homologarAmazonica } className="is-info">Homologar Amazonica</Button>
                                    <Button type="button" onClick={ this.onClick_homologarTodos } className="is-info">Homologar Todos</Button>
                            </div>
                            ):""}
                        </div>
                        
                    </div>
                    <div className="b-table has-pagination">
                        <div className="table-wrapper">
                                <table id="tblDarwinHomologar"
                                    className="table is-fullwidth is-bordered is-hoverable is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th className="is-sortable">#</th>
                                            <th>Nombre científico</th>
                                            <th>cites</th>
                                            <th>cites.org</th>
                                            <th>uicn</th>
                                            <th>uicnredlist</th>
                                            <th>Amazónica</th>
                                            <th>Homologado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>                            
                        </div>

                    </div>
                </div>
                </div>
             </section>
        )
    }
}

export default connect(null, {set_datapage})(Darwin)